const styles = ({ variables, breakpoints, mixins }) => ({
  page: {
    composes: 'pageLayout loginPage',
    marginBottom: '-12em',
    position: 'relative',
    zIndex: 100,
  },
  bg: {
    width: '100%',
    height: 0,
    bottom: 0,
    position: 'relative',
    zIndex: 100,
    [breakpoints.lg]: {
      position: 'absolute',
      display: 'block',
      height: '100vh',
      top: 0,
      width: '50%',
      left: '50%',
    },
  },
  bgImage: {
    composes: 'login_bgImage',
    position: 'relative',
    [breakpoints.lg]: {
      position: 'absolute',
      display: 'block',
      height: '100vh',
      top: 0,
      width: '100%',
      left: 0,
      backgroundImage: 'url(/images/loginBg.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'bottom center',
    },
  },
  loginOverlay: {
    composes: 'login_overlay',
    bottom: 0,
    position: 'relative',
    zIndex: 1,
    [breakpoints.lg]: {
      position: 'absolute',
      display: 'block',
      height: '100vh',
      top: 0,
      width: '100%',
      left: 0,
      backgroundColor: 'transparent',
      backgroundSize: 'cover',
      backgroundPosition: 'bottom center',
    },
  },
  slice: {
    position: 'absolute',
    bottom: 0,
    zIndex: 2,
    [breakpoints.lg]: {
      width: '50%',
      top: 0,
      backgroundImage:
        'url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSI1N3B4IiBoZWlnaHQ9IjEwMjRweCIgdmlld0JveD0iMCAwIDU3IDEwMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+ICAgICAgICA8dGl0bGU+R3JvdXA8L3RpdGxlPiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4gICAgPGRlZnM+ICAgICAgICA8cmVjdCBpZD0icGF0aC0xIiB4PSIwIiB5PSIwIiB3aWR0aD0iNTciIGhlaWdodD0iMTAyNCI+PC9yZWN0PiAgICA8L2RlZnM+ICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgaWQ9Ikdyb3VwIj4gICAgICAgICAgICA8bWFzayBpZD0ibWFzay0yIiBmaWxsPSJ3aGl0ZSI+ICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI3BhdGgtMSI+PC91c2U+ICAgICAgICAgICAgPC9tYXNrPiAgICAgICAgICAgIDxnIGlkPSJSZWN0YW5nbGUiPjwvZz4gICAgICAgICAgICA8cG9seWdvbiBpZD0iUmVjdGFuZ2xlIiBmaWxsPSIjRkNGQ0ZDIiBtYXNrPSJ1cmwoI21hc2stMikiIHBvaW50cz0iLTY4MyAwIDU3IDAgNCAxMDI0IC02ODMgMTAyNCI+PC9wb2x5Z29uPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+)',
      height: 'auto',
      backgroundSize: 'unset',
    },
  },
  logoContainer: {
    composes: 'logoContainer',
    height: '6em',
    margin: '1em 0',
    '.logo': {
      marginTop: '3rem',
    },
  },
  header: {
    composes: 'login_title',
  },
  container: {
    [breakpoints.lg]: {
      maxWidth: '30em',
      paddingBottom: 0,
    },
    '& h2': {
      margin: 0,
      fontSize: '20px',
    },
    '& p': {
      marginTop: 0,
    },
  },
  content: {
    overflow: 'hidden',
    transition: 'max-height 0.3s cubic-bezier(1, 0, 1, 0)',
    height: 'auto',
    maxHeight: 999,
  },
  icon: {
    display: 'block',
    position: 'fixed',
    bottom: 40,
    right: 20,
    zIndex: 999,
    fontSize: 18,
    cursor: 'pointer',
    color: 'white',
    padding: 0,
    transform: 'rotate(-90deg)',
    filter: 'invert(100%)',
  },
  grid: {
    display: 'block !important',
  },
  '@global': {
    '.pageLayout': {
      minHeight: '100%',
    },
    body: {
      ...mixins.init(),
      backgroundColor: variables.colors.light,
      color: variables.colors.dark,
    },
    h1: {
      ...variables.type.h1,
    },
  },
  buttonToggle: {
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    width: '100%',
    textAlign: 'left',
    padding: 0,
    fontWeight: 700,
    display: 'block',
    color: 'inherit',
  },
});

export default styles;
